export const SMALL ="sm"
export const MEDIUM ="md"
export const LARGE ="lg"
export const XLARGE ="xl"
export const X1LARGE ="2xl"
export const X2LARGE ="3xl"
export const X6LARGE ="6xl"
export const FILL_PARENT = "100%"
export const FILL_90PARENT = "90%"
export const FILL_80PARENT = "80%"
export const FILL_70PARENT = "70%"
export const FILL_60PARENT = "60%"
export const FILL_50PARENT = "50%"
export const FILL_40PARENT = "40%"
export const FILL_30PARENT = "30%"
export const FILL_20PARENT = "20%"
export const FILL_10PARENT = "10%"
export const FILL_85PARENT = "85%"
export const FILL_75PARENT = "75%"
export const FILL_65PARENT = "65%"
export const FILL_55PARENT = "55%"
export const FILL_45PARENT = "45%"
export const FILL_35PARENT = "35%"
export const FILL_25PARENT = "25%"
export const FILL_15PARENT = "15%"
export const FILL_5PARENT = "5%"

//Positions
export const FIXED="fixed"
export const RELATIVE="relative"
export const ABSOLUTE="absolute"
export const STICKY="sticky"

//Font Weight
export const BOLD = "bold"
export const ITALIC = "italic"
export const NORMAL = "normal"

//GridTempletColumns
export const R1="repeat(1,1fr)"
export const R2="repeat(2,1fr)"
export const R3="repeat(3,1fr)"
export const R4="repeat(4,1fr)"
export const R5="repeat(5,1fr)"
export const R6="repeat(6,1fr)"
export const R7="repeat(7,1fr)"
export const R8="repeat(8,1fr)"
export const R9="repeat(9,1fr)"
export const R10="repeat(10,1fr)"
export const R11="repeat(11,1fr)"
export const R12="repeat(12,1fr)"

//Margins
export const AUTO = "auto"

//curson
export const POINTER ="pointer"

//Alignments
export const CENTER = "center"
export const LEFT = "left"
export const TOP = "top"
export const BOTTOM = "bottom"
export const RIGHT = "right"
export const START = "start"
export const SB = "space-between"
export const SE = "space-evenly"

//none
export const NONE = "none"


//Flex direction
export const ROW = "row"
export const COLUMN = "column"

//border
export const SOLID= "solid"

//text decoration
export const LINE_THROUGH = "line-through"
export const UNDERLINE = "underline"

//types
export const CHECK_BOX = "checkbox"


//Colors
export const TRANSPARENT = "transparent"
export const BACKGROUND = "#ececec"
export const ALICEBLUE = "aliceblue"
export const LIGHTSALMON = "lightsalmon"
export const ANTIQUEWHITE = "antiquewhite"
export const LIGHTSEAGREEN = "lightseagreen"
export const AQUA = "aqua"
export const LIGHTSKYBLUE = "lightskyblue"
export const AQUAMARINE = "aquamarine"
export const LIGHTSLATEGRAY = "lightslategray"
export const AZURE = "azure"
export const LIGHTSTEELBLUE = "lightsteelblue"
export const BEIGE = "beige"
export const LIGHTYELLOW = "lightyellow"
export const BISQUE = "bisque"
export const LIME = "lime"
export const BLACK = "black"
export const LIMEGREEN = "limegreen"
export const BLANCHEDALMOND = "blanchedalmond"
export const LINEN = "linen"
export const BLUE = "blue"
export const MAGENTA = "magenta"
export const BLUEVIOLET = "blueviolet"
export const MAROON = "maroon"
export const BROWN = "brown"
export const MEDIUMAQUAMARINE = "mediumaquamarine"
export const BURLYWOOD = "burlywood"
export const MEDIUMBLUE = "mediumblue"
export const CADETBLUE = "cadetblue"
export const MEDIUMORCHID = "mediumorchid"
export const CHARTREUSE = "chartreuse"
export const MEDIUMPURPLE = "mediumpurple"
export const CHOCOLATE = "chocolate"
export const MEDIUMSEAGREEN = "mediumseagreen"
export const CORAL = "coral"
export const MEDIUMSLATEBLUE = "mediumslateblue"
export const CORNFLOWERBLUE = "cornflowerblue"
export const MEDIUMSPRINGGREEN = "mediumspringgreen"
export const CORNSILK = "cornsilk"
export const MEDIUMTURQUOISE = "mediumturquoise"
export const CRIMSON = "crimson"
export const MEDIUMVIOLETRED = "mediumvioletred"
export const CYAN = "cyan"
export const MIDNIGHTBLUE = "midnightblue"
export const DARKBLUE = "darkblue"
export const MINTCREAM = "mintcream"
export const DARKCYAN = "darkcyan"
export const MISTYROSE = "mistyrose"
export const DARKGOLDENROD = "darkgoldenrod"
export const MOCCASIN = "moccasin"
export const DARKGRAY = "darkgray"
export const NAVAJOWHITE = "navajowhite"
export const DARKGREEN = "darkgreen"
export const NAVY = "navy"
export const DARKKHAKI = "darkkhaki"
export const OLDLACE = "oldlace"
export const DARKMAGENTA = "darkmagenta"
export const OLIVE = "olive"
export const DARKOLIVEGREEN = "darkolivegreen"
export const OLIVEDRAB = "olivedrab"
export const DARKORANGE = "darkorange"
export const ORANGE = "orange"
export const DARKORCHID = "darkorchid"
export const ORANGERED = "orangered"
export const DARKRED = "darkred"
export const ORCHID = "orchid"
export const DARKSALMON = "darksalmon"
export const PALEGOLDENROD = "palegoldenrod"
export const DARKSEAGREEN = "darkseagreen"
export const PALEGREEN = "palegreen"
export const DARKSLATEBLUE = "darkslateblue"
export const PALETURQUOISE = "paleturquoise"
export const DARKSLATEGRAY = "darkslategray"
export const PALEVIOLETRED = "palevioletred"
export const DARKTURQUOISE = "darkturquoise"
export const PAPAYAWHIP = "papayawhip"
export const DARKVIOLET = "darkviolet"
export const PEACHPUFF = "peachpuff"
export const DEEPPINK = "deeppink"
export const PERU = "peru"
export const DEEPSKYBLUE = "deepskyblue"
export const PINK = "pink"
export const DIMGRAY = "dimgray"
export const PLUM = "plum"
export const DODGERBLUE = "dodgerblue"
export const POWDERBLUE = "powderblue"
export const FIREBRICK = "firebrick"
export const PURPLE = "purple"
export const FLORALWHITE = "floralwhite"
export const RED = "red"
export const FORESTGREEN = "forestgreen"
export const ROSYBROWN = "rosybrown"
export const FUCHSIA = "fuchsia"
export const ROYALBLUE = "royalblue"
export const GAINSBORO = "gainsboro"
export const SADDLEBROWN = "saddlebrown"
export const GHOSTWHITE = "ghostwhite"
export const SALMON = "salmon"
export const GOLD = "gold"
export const SANDYBROWN = "sandybrown"
export const GOLDENROD = "goldenrod"
export const SEAGREEN = "seagreen"
export const GRAY = "gray"
export const SEASHELL = "seashell"
export const GREEN = "green"
export const SIENNA = "sienna"
export const GREENYELLOW = "greenyellow"
export const SILVER = "silver"
export const HONEYDEW = "honeydew"
export const SKYBLUE = "skyblue"
export const HOTPINK = "hotpink"
export const SLATEBLUE = "slateblue"
export const INDIANRED = "indianred"
export const SLATEGRAY = "slategray"
export const INDIGO = "indigo"
export const SNOW = "snow"
export const IVORY = "ivory"
export const SPRINGGREEN = "springgreen"
export const KHAKI = "khaki"
export const STEELBLUE = "steelblue"
export const LAVENDER = "lavender"
export const TAN = "tan"
export const LAVENDERBLUSH = "lavenderblush"
export const TEAL = "teal"
export const LAWNGREEN = "lawngreen"
export const THISTLE = "thistle"
export const LEMONCHIFFON = "lemonchiffon"
export const TOMATO = "tomato"
export const LIGHTBLUE = "lightblue"
export const TURQUOISE = "turquoise"
export const LIGHTCORAL = "lightcoral"
export const VIOLET = "violet"
export const LIGHTCYAN = "lightcyan"
export const WHEAT = "wheat"
export const LIGHTGOLDENRODYELLOW = "lightgoldenrodyellow"
export const WHITE = "white"
export const LIGHTGREEN = "lightgreen"
export const WHITESMOKE = "whitesmoke"
export const LIGHTGREY = "lightgrey"
export const YELLOW = "yellow"
export const LIGHTPINK = "lightpink"
export const YELLOWGREEN = "yellowgreen"
